import React, { Suspense, useEffect, useState } from "react";
import { Col } from 'reactstrap';
import { Tab } from 'semantic-ui-react';
import Summary from './Components/summary'
import Comments from './Components/Comments'
import Documments from './Components/Documents/index'
import Axios from 'axios';
import { ModelContainerDetail } from './Components/Model';
import Loader from "../../../Global/Loader";
import Form from './Components/Form'
import swal from "sweetalert";
import { Services } from '../Services'

const Comentarios = [
	{ ComType: "", ComTypeId: 1, Comment: "Comentario de Containers", CommentId: "", Date: "09-10-2020", Module: "Comentario", ModuleId: 1, RowId: "", UpdateBy: "API" },
	{ ComType: "", ComTypeId: 1, Comment: "Otro Comentario de Containers", CommentId: "", Date: "09-10-2020", Module: "jeje", ModuleId: 1, RowId: "", UpdateBy: "API" }
]
const IncidentType =
	[
		{ key: 1, value: 'A', text: 'Abandoned' },
		{ key: 2, value: 'S', text: 'Sinister' },
	]

function ContainerManagementDetail(props) {

	const [idShipm, setIdShip] = useState(1)
	const [idContainer, setIdContainer] = useState(1)
	const [steps] = useState([
		{ label: "Booking Confirmation", value: "", id: 2, completed: false, order: 1, idStep: "", middleStep: "", },
		{ label: "ATD", value: "", id: 4, completed: false, order: 2, middle: false, idStep: "", middleStep: "", },
		{ label: "ATA", value: "", id: 5, completed: false, order: 3, idStep: "step3", middleStep: "" },
		{ label: "Out of Gate", value: "", id: 8, completed: false, order: 4, idStep: "step3", middleStep: "" },
		{ label: "Delivery at Destination", value: "", id: 10, completed: false, order: 5, idStep: "step3", middleStep: "" },
		{ label: "Empty Returned", value: "", id: 9, completed: false, order: 7, idStep: "step7", middleStep: "" },
	])
	const [events, setEvents] = useState([
		{ label: "Booking Confirmation", value: "" },
		{ label: "ATD", value: "" },
		{ label: "ATA", value: "" },
		{ label: "Out of Gate", value: "" },
		{ label: "Delivery at Destination", value: "", },
		{ label: "Empty Returned", value: "", },
	])
	const [Documentos, setDocumentos] = useState([])

	const [dataContainer, setDataContainer] = useState([])
	const [Catalogos, setCatalogos] = useState({ ...ModelContainerDetail().Catalogos })

	const [ModelContainers, setModelContainers] = useState({ ...ModelContainerDetail() })
	let [ActiveLoader, setActiveLoader] = useState(false)
	const [editForm] = useState({ ...Form })


	function handleChange(evt, data, idFe) {
		let ModelSend = { ...ModelContainers.Model };
		if (data) {

			let id = data.id;
			let value = data.value;
			ModelSend[id].value = value;
			if (data.id === 'IncidentType' && data.value === 'A') {
				ModelContainers.Model['IncidentDate'].hidden = false
				ModelContainers.Model['SiniesterId'].hidden = true
			}
			else if (data.id === 'AdditionalComment') {

			}

			else {
				ModelContainers.Model['IncidentDate'].hidden = false
				ModelContainers.Model['SiniesterId'].hidden = false
			}
		}
		else {
			let value = evt.format('YYYY-MM-DD');
			let id = idFe;
			ModelSend[id].value = value;
		}
		setModelContainers({ ModelContainers, ...ModelContainers })
	}

	const handleCancel = () => {
		ModelContainers.Model['IncidentDate'].value = null;
		ModelContainers.Model['IncidentType'].value = null;
		ModelContainers.Model['SiniesterId'].value = null;
		ModelContainers.Model['AdditionalComment'].value = null;

		ModelContainers.Model['SiniesterId'].hidden = true;
		ModelContainers.Model['IncidentDate'].hidden = true;

		setModelContainers({ ModelContainers, ...ModelContainers })
	};

	const UpdateContainer = () => {
		setActiveLoader(false)
		Axios.put(`${Services.UpdateContainers.path}Containers/UpdateContainer/${props.idContainer}`, ModelContainers.Model)
			.then((response) => {
				ContainerId(props.idContainer)
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	const CreateIncident = () => {
		setActiveLoader(false)
		Axios.post(`${Services.CreateIncidencia.path}Containers/CreateIncident/`, ModelContainers.Model)
			.then((response) => {
				ContainerId(props.idContainer)
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	const UpdateIncident = () => {
		editForm.Incident[0].type = 'info'
		editForm.Incident[1].type = 'info'
		editForm.Incident[2].type = 'info'
		setActiveLoader(false)

		Axios.put(`${Services.UpdateIncidencia.path}Containers/UpdateIncident/`, ModelContainers.Model)
			.then((response) => {
				ContainerId(props.idContainer)
			})
			.catch((error) => {
				console.warn(error);
			});
	}


	const DeleteIncidencia = () => {
		let idIncident = dataContainer.IncidentId
		swal({
			title: "Are you sure?",
			text: "Once removed, you will not be able to recover the incident.",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		})
			.then((willDelete) => {
				if (willDelete) {
					// setActiveLoader(false)
					Axios.post(`${Services.DeleteIncidencia.path}Containers/deleteIncident/${idIncident}`, ModelContainers.Model)
						.then((response) => {
							// console.log('response', response);
							ContainerId(props.idContainer)
							swal("Incident has been deleted!", {
								icon: "success",
							});
						})
						.catch((error) => {
							console.warn(error);
						});
				}
			});
	}


	const ContainerId = React.useCallback(async (id) => {
		try {
			const url = `${Services.ContainerNextToArriveId.path}Containers/dataContainer/${id}`
			const resulContainer = await Axios.get(url)
			let data = resulContainer.data.data.rows[0]
			setIdShip(data.ShipmentId)
			setIdContainer(data.ContainerId)

			setDataContainer(data)
			ModelContainers.Model['ContainerId'].value = data.ContainerId
			ModelContainers.Model['IncidentId'].value = data.IncidentId
			ModelContainers.Model['ContainerNo'].value = data.NoContainer
			ModelContainers.Model['ContainerType'].value = data.ContainerType
			ModelContainers.Model['Carrier'].value = data.Carrier
			ModelContainers.Model['Voyage'].value = data.Voyage_FlightNumber
			ModelContainers.Model['PortTerminalId'].value = data.PortTerminalId
			ModelContainers.Model['PortTerminal'].value = data.PortTerminal
			ModelContainers.Model['dgr'].value = data.DGR
			ModelContainers.Model['imo'].value = data.IMO
			ModelContainers.Model['Consignee'].value = data.ConsigneeName
			ModelContainers.Model['From'].value = data.FROM
			ModelContainers.Model['To'].value = data.TO
			ModelContainers.Model['FreeDays'].value = data.FreeDays
			ModelContainers.Model['CustomerFreeDays'].value = data.CustomerFreeDays
			ModelContainers.Model['ETD'].value = data.ETD
			ModelContainers.Model['ATD'].value = data.ATD
			ModelContainers.Model['ETA'].value = data.ETA
			ModelContainers.Model['ATA'].value = data.ATA
			ModelContainers.Model['MaxEmptyReturned'].value = data.MaxEmptyReturned
			ModelContainers.Model['MaxCarrierEmptyReturned'].value = data.MaxCarrierEmptyReturned
			ModelContainers.Model['OutGate'].value = data.OutGate
			ModelContainers.Model['DeliveryDestination'].value = data.DeliveryDestination
			ModelContainers.Model['EmptyReturned'].value = data.EmptyReturned
			ModelContainers.Model['Dimensions'].value = data.Dimension
			ModelContainers.Model['TotalPieces'].value = data.Pieces
			ModelContainers.Model['TotalWeight'].value = data.Weight
			ModelContainers.Model['TotalVolume'].value = data.Volume
			ModelContainers.Model['Cargo'].value = data.DescriptionLoad
			ModelContainers.Model['incidenttype'].value = data.incidenttype ? data.incidenttype : 'Not Incident'
			ModelContainers.Model['incidenttypeId'].value = data.incidentdescription
			ModelContainers.Model['IncidentDateInfo'].value = data.IncidentDate
			ModelContainers.Model['AdditionalCommentInfo'].value = data.AdditionalComment
			ModelContainers.Model['IncidentType'].value = data.IncidentDescription
			ModelContainers.Model['IncidentDate'].value = data.IncidentDate
			ModelContainers.Model['AdditionalComment'].value = data.AdditionalComment
			ModelContainers.Model['CreateUser'].value = data.createusersiniester
			ModelContainers.Model['CreateDay'].value = data.createdatesiniester
			ModelContainers.Model['CreateUserId'].value = props._user
			ModelContainers.Model['ShipmentId'].value = data.ShipmentId

			ModelContainers.Model['CreateUser'].hidden = data.incidentdescription ? false : true
			ModelContainers.Model['CreateDay'].hidden = data.incidentdescription ? false : true

			setModelContainers({ ModelContainers, ...ModelContainers })
			setActiveLoader(true)

		} catch (error) {
			console.log('The Error-->', error);
			setActiveLoader(true)
		}
	}, [])


	const EventsContainer = React.useCallback(async () => {
		try {
			const url = `${Services.EventsContainer.path}events/all/2/${idContainer}`
			const resulEvent = await Axios.get(url)
			let dataEvents = resulEvent.data.data
			Eventos(dataEvents)
		} catch (error) {
			console.log('The Error-->', error);
		}
	}, [idContainer])


	const GetDocumments = React.useCallback(async (idCon) => {
		try {
			const url = `${Services.Documents.path}Documents/DocummentsContainers/${idCon ? idCon : idContainer}`
			const resulDocuments = await Axios.get(url)
			let dataDocuments = resulDocuments.data.data
			setDocumentos(dataDocuments)
		} catch (error) {
			console.log('The Error-->', error);
		}
	}, [idContainer])



	const CatalogosContainer = React.useCallback(async () => {
		try {
			const url = `${Services.Catalogos.path}Catalogos/Catalogos/`
			const resultCatalogos = await Axios.get(url)
			let catalogoPort = resultCatalogos.data.data[0].catalogoPort
			let catalogoDays = resultCatalogos.data.data[0].catalogoDays
			let catalogoSinies = resultCatalogos.data.data[0].catalogoSinesters

			let newCatalogoPort = [];
			let newCatalogoDays = [];
			let newCatalogoSiniester = [];

			catalogoPort.map((e) => {
				newCatalogoPort.push({ 'key': e.PortTerminalId, 'value': e.PortTerminalId, 'text': e.PortTerminal })
				return e
			})
			catalogoDays.map((e) => {
				newCatalogoDays.push({ 'key': e.Dias, 'value': e.Dias, 'text': e.Dias })
				return e
			})
			catalogoSinies.map((e) => {
				newCatalogoSiniester.push({ 'key': e.SiniesterId, 'value': e.SiniesterId, 'text': e.Siniester })
				return e
			})
			setCatalogos({
				'PortTerminalId': newCatalogoPort,
				'FreeDays': newCatalogoDays,
				'SiniesterId': newCatalogoSiniester,
				'IncidentType': IncidentType,
				'incidenttype': IncidentType,
			})
		} catch (error) {
			console.log('The Error-->', error);
		}
	}, [])


	const Eventos = (data) => {
		let dataEventos = data;
		var findNext = false;
		steps.map((f) => {
			dataEventos.map((e) => {
				if (e.EventDescriptionId === f.id) {
					findNext = true;
					f.value = e.EventDate;
					if (e.InTimeLine === "1") {
						f.completed = true;
					} else {
						findNext = false;
					}
				} else {
					findNext = false;
				}
				if (findNext) {
					f.completed = true;
				}
				return e;
			});
			return f;
		});
		steps.sort(function (a, b) {
			return b.order - a.order;
		});
		let findTrue = false;
		steps.map((e) => {
			if (e.completed) {
				findTrue = true;
			}
			if (findTrue) {
				e.completed = true;
			}
			return e;
		});
		steps.sort(function (a, b) {
			return a.order - b.order;
		});
		setEvents(steps)
	}

	useEffect(() => {
		ContainerId(props.idContainer)
		EventsContainer()
		CatalogosContainer()
		GetDocumments(props.idContainer)
	}, [ContainerId, EventsContainer, CatalogosContainer, GetDocumments])

	return (
		<div className="content">
			<Loader hidden={ActiveLoader} />
			<hr></hr>
			<Col className='d-flex align-items-center'
				onClick={props.getIdContainer}
				style={{ cursor: 'pointer', padding: 0 }} >
				<div className='link-containers d-flex flex-row align-items-center'>
					<i className='fas fa-arrow-circle-left fa-3x mr-2' />
					<spam><h4><b>Back Containers</b></h4></spam>
				</div>
			</Col>
			<br></br>
			<div>
				<Tab
					menu={{
						secondary: true,
					}}
					panes={[
						{
							menuItem: 'Summary', render: () => <Suspense fallback={<div>Loading...</div>}>
								<Summary
									steps={events}
									Model={ModelContainers.Model}
									Catalog={Catalogos}
									dataContainer={dataContainer}
									onChange={handleChange}
									UpdateContainer={UpdateContainer}
									onCancel={handleCancel}
									CreateIncident={CreateIncident}
									UpdateIncident={UpdateIncident}
									DeleteIncidencia={DeleteIncidencia}
									ContainerId={ContainerId}
								/></Suspense>
						},
						{ menuItem: 'Comments', render: () => <Suspense fallback={<div>Loading...</div>}> <Comments data={Comentarios} idContainer={props.idContainer} _user={props._user} /></Suspense> },
						{ menuItem: 'Documents', render: () => <Suspense fallback={<div>Loading...</div>}> <Documments dataDocuments={Documentos} GetDocumments={GetDocumments} idContainer={props.idContainer} /></Suspense> }
					]}
				/>
			</div>
		</div>
	);
}

export default ContainerManagementDetail;